import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { getDateWithoutSeconds } from "../../utils/getDateWithoutSeconds";
import { IPost, IStatusCodes } from "../../api/tenantCommunityInboxPost";
import kafdLogo from "../../images/kafdLogo.jpg";
import communityLogo from "../../images/communityLogo.jpg";
import useTenantCommunityInboxPostContainer from "../../containers/TenantCommunityInbox/useTenantCommunityInboxPostContainer";
import { Link } from "@mui/material";

const statusesOrderAndColor = [
  {
    id: IStatusCodes.Pending,
    color: "rgb(161 98 7)",
    backgroundColor: "rgb(254 252 232)",
  },
  {
    id: IStatusCodes.Scheduled,
    color: "rgb(126 34 206)",
    backgroundColor: "rgb(250 245 255)",
  },
  {
    id: IStatusCodes.Published,
    color: "rgb(21 128 61)",
    backgroundColor: "rgb(240 253 244)",
  },
  {
    id: IStatusCodes.Rejected,
    color: "rgb(55 65 81)",
    backgroundColor: "rgb(249 250 251)",
  },
];

const sortByStatus = (a: IPost, b: IPost) => {
  const aOrder = statusesOrderAndColor.findIndex((el) => el.id === a.status.id);
  const bOrder = statusesOrderAndColor.findIndex((el) => el.id === b.status.id);

  return aOrder - bOrder;
};

const getStatusColor = (status: IPost["status"]) => {
  const { id } = status;

  const statusColor = statusesOrderAndColor.find(
    (statusMetaData) => statusMetaData.id === id
  )?.color;
  return statusColor;
};

const getStatusBackgroundColor = (status: IPost["status"]) => {
  const { id } = status;

  const statusColor = statusesOrderAndColor.find(
    (statusMetaData) => statusMetaData.id === id
  )?.backgroundColor;
  return statusColor;
};

type IProps = {
  rows: IPost[];
};

const Inbox: React.FC<IProps> = ({ rows }) => {
  const { handleEdit } = useTenantCommunityInboxPostContainer();

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Post details</TableCell>
            <TableCell>Created</TableCell>
            <TableCell>Published</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Created by</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.sort(sortByStatus).map((row) => (
            <TableRow
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              {/* <TableCell component="th" scope="row">
                {row.title}
              </TableCell> */}
              <TableCell>
                <div
                  // className="flex items-center"
                  style={{ display: "flex", justifyItems: "center" }}
                >
                  <div
                    // className="h-11 w-11 flex-shrink-0"
                    style={{ height: "50px", width: "50px" }}
                  >
                    <img
                      // className="h-11 w-11 rounded-full"
                      style={{
                        height: "50px",
                        width: "50px",
                        borderRadius: "100%",
                      }}
                      src={row.isNeighbourPost ? communityLogo : kafdLogo}
                      alt=""
                    />
                  </div>
                  <div
                    // className="ml-4"
                    style={{ marginLeft: "8px " }}
                  >
                    <div
                      // className="font-medium text-gray-900 text-wrap line-clamp-1"
                      style={{
                        // textWrap: "wrap",
                        overflow: "hidden",
                        display: "-webkit-box",
                        // "-webkit-box-orient": "vertical",
                        // "-webkit-line-clamp": 1,
                      }}
                    >
                      {row.title}
                    </div>
                    <div
                      // className="mt-1 text-gray-500 text-wrap line-clamp-2"
                      style={{
                        // textWrap: "wrap",
                        overflow: "hidden",
                        display: "-webkit-box",
                        // "-webkit-box-orient": "vertical",
                        // "-webkit-line-clamp": 2,
                      }}
                    >
                      {row.message}
                    </div>
                  </div>
                </div>
              </TableCell>
              {/* <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0 max-w-96">
                <div className="flex items-center">
                  <div className="h-11 w-11 flex-shrink-0">
                    <img
                      className="h-11 w-11 rounded-full"
                      src={row.image}
                      alt=""
                    />
                  </div>
                  <div className="ml-4">
                    <div className="font-medium text-gray-900 text-wrap line-clamp-1">
                      {row.title}
                    </div>
                    <div className="mt-1 text-gray-500 text-wrap line-clamp-2">
                      {row.message}
                    </div>
                  </div>
                </div>
              </td> */}
              <TableCell>
                {row.createdAt ? getDateWithoutSeconds(row.createdAt) : "-"}
              </TableCell>
              <TableCell>
                {row.publishedAt ? getDateWithoutSeconds(row.publishedAt) : "-"}
              </TableCell>
              <TableCell>
                <span
                  // className={`inline-flex items-center rounded-md bg-${getStatusColor(
                  //   row.status
                  // )}-50 px-2 py-1 text-xs font-medium text-${getStatusColor(
                  //   row.status
                  // )}-700 ring-1 ring-inset ring-${getStatusColor(
                  //   row.status
                  // )}-600/20`}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    borderRadius: "0.375rem",
                    padding: "0.25rem 0.5rem",
                    color: getStatusColor(row.status),
                    backgroundColor: getStatusBackgroundColor(row.status),
                  }}
                >
                  {row.status.label}
                </span>
              </TableCell>
              <TableCell>
                {row.isNeighbourPost ? row.createdBy : "Admin"}
              </TableCell>
              <TableCell>
                <Link
                  component="button"
                  variant="body2"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit(row.id);
                  }}
                >
                  View
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Inbox;
